export const getPriceWithCurrency = (price?: number | null, currency?: string, locale?: string) => {
  if (!price || !currency) return '';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(price);
};
